var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoonIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dark-Mode-Toggle",
    transform: "translate(-27 -4)",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dark-mode-light-mode-toggle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy",
    transform: "translate(27 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.89 1.084C1.834 2.236.637 4.17.637 6.426c0 3.694 3.266 6.934 6.989 6.934 1.96 0 3.824-1.03 5.074-2.24a9.411 9.411 0 01-1.935.212c-4.184 0-7.588-3.23-7.588-7.2 0-1.171.22-2.132.713-3.048m3.736 12.912C3.563 13.996 0 10.458 0 6.426 0 3.556 1.74 1.162 4.653.022a.319.319 0 01.368.49C4.174 1.617 3.813 2.7 3.813 4.133c0 3.62 3.118 6.564 6.952 6.564.955 0 2.028-.188 2.8-.49a.318.318 0 01.368.49c-1.26 1.643-3.7 3.3-6.307 3.3",
    id: "Fill-1"
  })))))));
}
SvgMoonIcon.displayName = 'MoonIcon';
export default SvgMoonIcon;